module.exports = __webpack_public_path__ + "static/media/burguer.b3d490aa.mp3";